import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";

import { Media, MediaContextProvider } from "../../styles/Media.js";

import NotificationMessage from "./NotificationMessage.jsx";

import { NOTIFICATIONS } from "../../state/reducers/notifications/notificationConstants.js";
import { AT_TYPES } from "../../constants/entity.js";

import { createAction } from "../../state/actions/actionUtils.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class NotificationTray extends PureComponent {
  static propTypes = {
    notifications: PropTypes.array,
    dismiss: PropTypes.func.isRequired,
    copy: PropTypes.func.isRequired
  };

  // -- HANDLERS -- //

  onDismiss = id => {
    this.props.dismiss(id);
  };

  // -- RENDER -- //

  renderMessages = () => {
    return this.props.notifications.map(item => {
      if (!item || item["@type"] !== AT_TYPES.MESSAGE) return null;

      return (
        <NotificationMessage
          key={item.id}
          id={item.id}
          title={item.title}
          message={item.description}
          objectEntity={item.object}
          info={item.type === "info"}
          positive={item.type === "success"}
          warning={item.type === "warning"}
          negative={item.type === "error"}
          timed={false}
          onDismiss={this.onDismiss}
        />
      );
    });
  };

  renderTray = mobile => {
    return (
      <div className={`notification-tray${mobile ? " mobile" : ""}`}>
        {this.renderMessages()}
      </div>
    );
  };

  render() {
    if (this.props.notifications.length < 1) return null;

    return (
      <MediaContextProvider>
        <Media lessThan="smallTablet">{this.renderTray(true)}</Media>
        <Media greaterThanOrEqual="smallTablet">{this.renderTray()}</Media>
      </MediaContextProvider>
    );
  }
}

const mapStateToProps = state => ({
  notifications: state.notifications.notifications,
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  dismiss: id => dispatch(createAction(NOTIFICATIONS.DELETE, { id }))
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationTray);
